/** Assemble des classes CSS en ignorant les valeurs falsy. */
export const cx = (...classes: readonly (string | false | null | undefined)[]): string =>
  classes.filter(Boolean).join(' ');
